export class DemoSampleAllocationDetails {
    RowNum: number;
    RequestNo: number;
    region: string;
    RMHCode: string;
    ProductName: string;
    FinalQTY: number;
    FinalApproveQTY: number;
    EmployeeName: string;
    QTYAllocation: number;
    NoOfUnit: number;
    PackSize: string;
    Month: string;
    Status: string;
    isAllocated: number;
}


export class RoleCodeModel {
    RoleID: number;
    RoleCode: string;

}
export class EmployeeNameModel {
    TMHEmployeeName: string;
    UMHEmployeeName: string;

}
export class FilterModel {
    UserId: string;
    RoleId: string;
    ReqType: string;
    SBUCode: string;
    DivisionCode: string;
    ZoneCode: string;
    RegionCode: string;
    UserRole: string;
    SelectedEmplyoeeName: string;
    SelectedStatus: string;
    Product: string;
    Designation: string;
    UserName:string;
    Year:number;
}
